import React, { useState } from 'react';
import { addHeading } from '../../services/materialCalculatorAPI';
import './AddHeading.css'; // import your custom CSS

const AddHeading = () => {
  const [name, setName] = useState('');
  const [unit, setUnit] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await addHeading({ name, unit });
    setMessage(res.message);
    if (res.success) {
      setName('');
      setUnit('');
    }
  };

  return (
    <div className="add-heading-container">
      <h2 className="heading-title">Add New Work Heading</h2>
      <form onSubmit={handleSubmit} className="add-heading-form">
        <input
          type="text"
          className="input-field"
          placeholder="Heading Name "
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <input
          type="text"
          className="input-field"
          placeholder="Unit (e.g., sqm)"
          value={unit}
          onChange={(e) => setUnit(e.target.value)}
          required
        />
        <button type="submit" className="submit-button">
          Add Heading
        </button>
        {message && <p className="form-message">{message}</p>}
      </form>
    </div>
  );
};

export default AddHeading;
